<template>
  <div class="container">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>化学成分1:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.chemistryT"></lk-input>
          </div>
          <div class="queryItem">
            <label>化学成分2:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.chemistryS"></lk-input>
          </div>
          <div class="queryItem">
            <label>成分分类1:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.chemistryTypeT"></lk-input>
          </div>
          <div class="queryItem">
            <label>成分分类2:</label>
            <lk-input placeholder='请输入' class="item" clearable v-model.trim="query.chemistryTypeS"></lk-input>
          </div>
          <div class="queryItem">
            <label>综合评级:</label>
            <lk-select v-model="query.rate" clearable filterable  class="item">
              <lk-option v-for="rate in sharedRateList" :key="rate.id" :value="rate.id">{{rate.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns" v-if="handlePermission('interactionAdd')">
          <lk-button class="mr8" type='primary' @click="$router.push({ name: 'interactionAdd' })">添加相互作用</lk-button>
          <lk-button class="mr8" type='primary' @click="toBatchAdd">批量导入</lk-button>
          <span>
            <a @click="downLoad('https://linkdoc-erp.oss-cn-beijing.aliyuncs.com/erp-uid-3063/502207191657.xlsx?Expires=3213421077&OSSAccessKeyId=LTAIhQ088Y2NYQem&Signature=JvlB217VvBSa1WDG%2FrZcYc4FOCs%3D', '成分相互作用导入模版.xlsx')" >导入模板</a>
          </span>
        </div>
        <lk-table
          border
          :columns='columns'
          :data='tableData'
        />
      </div>
    </QueryFrame>
    <lk-modal
      title='批量导入'
      v-model="isShow"
      :mask-closable="false"
      :closable="false"
      @on-ok="toUpload"
      @on-cancel="batchCancel"
    >
      <div style="display:flex;flex-direction:column;align-items:center;">
        <div class="uploader" @click="$refs.file.click()">
          <input type="file" ref="file" @change="fileReader" v-show="false">
          <p>
            <lk-icon type="ios-cloud-upload-outline" size="16"></lk-icon>点击上传
          </p>
        </div>
        <div style="margin-top:12px;" v-if="this.file">
          {{`上传的文件是:${this.file.name || ''}`}}
        </div>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import Axios from 'axios';
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import mapState from '../../../mixins/mapState';
import queryMixins from '../../../mixins/queryMixins';
import tools from '../../../services/tools';
import utils from '../../../libs/utils';

export default {
  name: 'InteractionList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  computed: {
    selectedTempGoodsIds() {
      const result = [];
      this.tempGoods.forEach((item) => {
        result.push(item);
      });
      return result;
    },
  },
  data() {
    return {
      sharedRateList: [
        {
          id: 1,
          name: '关注',
        },
        {
          id: 2,
          name: '不推荐合用',
        },
        {
          id: 3,
          name: '谨慎合用',
        },
        {
          id: 4,
          name: '禁忌合用',
        },
      ],
      isShow: false,
      query: {

      },
      loading: false,
      file: '',
      tableData: [],
      count: 0,
      page: 1,
      columns: [
        { title: '化学成分1', key: 'chemistryT', width: 100 },
        { title: '成分分类1', key: 'chemistryTypeT', width: 100 },
        { title: '化学成分2', key: 'chemistryS', width: 100 },
        { title: '成分分类2', key: 'chemistryTypeS', width: 100 },
        { title: '合用评级', key: 'rateName', width: 100 },
        {
          title: '相互作用内容',
          key: 'description',
          minWidth: 200,
          render: (h, { row }) => h('span', {
            domProps: {
              innerHTML: `${row.description.replace(/(\r\n|\n|\r)/gm, '<br />')}`,
            },
          }),
        },
        { title: '创建时间', key: 'createTime', width: 100 },
        { title: '修改时间', key: 'modifiedTime', width: 100 },
        {
          title: '操作',
          width: 100,
          fixed: 'right',
          render: (h, params) => h('div', [
            this.handlePermission('interactionEdit') && h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'interactionEdit', params: { id: params.row.id } });
                },
              },
            }, '编辑'),
            this.handlePermission('interactionDel') && h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$Modal.confirm({
                    title: '删除成分相互作用',
                    content: '确定删除该行相互作用信息？',
                    onOk: () => {
                      const temp = {
                        id: params.row.id,
                      };
                      tools.interactionDel(temp).then((res) => {
                        if (res.data.status === 200) {
                          this.$Message.success('删除成功');
                          this.getData();
                        } else {
                          this.$Message.error(res.data.error);
                        }
                      });
                    },
                  });
                },
              },
            }, '删除'),
          ]),
        },
      ],
    };
  },
  methods: {
    downLoad(url, name) {
      Axios.get(url, {
        responseType: 'blob',
      }).then((res) => {
        if (!res) {
          this.$Message.error('成分相互作用导入模版失败，请稍后重试');
        }
        utils.downFile(res.data, name);
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    toBatchAdd() {
      this.file = '';
      this.isShow = true;
    },
    fileReader(e) {
      this.loading = true;
      this.file = e.target.files[0];
      e.target.value = null;
    },
    batchCancel() {
      this.file = '';
    },
    toUpload() {
      if (this.file === '') {
        this.$Message.warning('请选择文件后重新导入');
        return;
      }
      const form = new FormData();
      form.append('file', this.file);
      tools.interactionBatchAdd(form).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('上传并导入完成');
          this.getData();
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      tools.interactionList(this.params).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data;
          this.count = data.count;
          data.list.forEach((item) => {
            item.rateName = this.sharedRateList.find(subItem => subItem.id === item.rate).name || '';
            item.createTime = utils.formatDateToSecond(item.createTime);
            item.modifiedTime = utils.formatDateToSecond(item.modifiedTime);
          });
          this.tableData = data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    clear() {
      this.query = {};
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style lang="less" scoped>
  .btns {
    margin-bottom: 12px;
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .margin-left {
    margin-left: 12px;
  }
  .margin-bottom {
    margin-bottom: 12px;
  }
  .select {
    width: 200px;
  }
  .uploader {
    height: 28px;
    width: 87px;
    border: 1px dashed #dedede;
    text-align: center;
    position: relative;
    cursor: pointer;
    line-height: 1.2;
    p {
      line-height: 28px;
      font-size: 12px
    }
  }
</style>
